import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';

// ─────────────────────────────────────────────────────────────
// useAutoCreate — opens a page's "create" modal automatically when
// the page is reached with `?new=1` (used by the Dashboard Quick
// Actions to jump straight into a create flow). Fires once, then
// strips the param so a refresh doesn't reopen it.
// ─────────────────────────────────────────────────────────────
export function useAutoCreate(openCreate: () => void, enabled = true) {
  const [params, setParams] = useSearchParams();
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    if (enabled && params.get('new') === '1') {
      handled.current = true;
      openCreate();
      const next = new URLSearchParams(params);
      next.delete('new');
      setParams(next, { replace: true });
    }
  }, [params, enabled, openCreate, setParams]);
}
